const TOKEN = /{{{\s*([A-Za-z_][A-Za-z0-9_]*)\s*}}}|{{\s*([A-Za-z_][A-Za-z0-9_]*)\s*}}/g

export function variableNames(subject, html) {
  const found = new Set()
  for (const match of `${subject || ''}\n${html || ''}`.matchAll(TOKEN)) found.add(match[1] || match[2])
  return Array.from(found).sort()
}

export function syncDescriptions(subject, html, current) {
  return variableNames(subject, html).reduce((next, name) => {
    next[name] = (current || {})[name] || ''
    return next
  }, {})
}
